import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { Logo } from "./Logo";

const Col = ({ title, links }) => (
  <div>
    <h3 className="text-xs uppercase tracking-[0.2em] font-bold text-[#F5E6A3] mb-4">{title}</h3>
    <ul className="space-y-2.5">
      {links.map(([label, to]) => (
        <li key={to}>
          <Link to={to} className="text-sm text-[#E5E0D8] hover:text-white transition-colors" data-testid={`footer-link-${to.replace(/[^a-z]+/g, "-")}`}>{label}</Link>
        </li>
      ))}
    </ul>
  </div>
);

export const Footer = () => (
  <footer className="bg-[#1E3A2B] text-[#FAF8F5] grain" data-testid="site-footer">
    <div className="container-site py-16 grid gap-12 lg:grid-cols-12">
      <div className="lg:col-span-4 space-y-5">
        <Logo light />
        <p className="text-sm text-[#E5E0D8] leading-relaxed max-w-sm">
          A community care organization offering in-home care services and housing programs, centered on dignity, respect and individualized support.
        </p>
        <p className="flex items-center gap-2 text-sm text-[#E5E0D8]"><Mail className="h-4 w-4" />
          <a href="mailto:admin@FriendshipPenCare.com" className="hover:text-white" data-testid="footer-email-link">admin@FriendshipPenCare.com</a>
        </p>
        <p className="flex items-start gap-2 text-sm text-[#E5E0D8]"><MapPin className="h-4 w-4 mt-0.5" />Serving the Greater Toronto Area, Ontario</p>
      </div>
      <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 gap-10">
        <Col title="Services" links={[["Find In-Home Care", "/in-home-care"], ["Independent Living", "/housing#independent-living"], ["Assisted Living (Coming Soon)", "/housing#assisted-living"]]} />
        <Col title="Get Involved" links={[["Join Our Care Team", "/careers"], ["Partner With Us", "/partner-with-us"], ["Contact", "/contact"]]} />
        <Col title="Company" links={[["About Us", "/about"], ["Privacy Notice", "/privacy"]]} />
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="container-site py-6 text-xs text-[#E5E0D8]/80 space-y-2">
        <p>
          Friendship Pen Care Services provides non-medical support and helps connect people with care and housing resources. Submitting an inquiry or application does not guarantee services, placement, availability, funding or employment; each request is reviewed individually.
        </p>
        <p>© {new Date().getFullYear()} Friendship Pen Care Services. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
